<div class="gap-6 flex flex-col" *ngIf="vm$ | async as vm">
	<atomic-button-group
		class="top-0"
		type="tab"
		[options]="tabs"
		[(ngModel)]="vm.selectedTab"
	></atomic-button-group>
	<ui-section
		[title]="'Charge Details'"
		data-intercom-target="charge-details-section"
	>
		<div section-content>
			<div class="w-full flex justify-between">
				<div class="flex-1 grid grid-cols-2 p-sm gap-4">
					<div class="flex-1 grid grid-cols-[2fr_3fr] p-sm">
						<p class="font-bold">Registered As</p>
						<div class="flex flex-col">
							<p>
								<span
									*ngFor="
										let lenderKeyValue of vm.selectedMortgage?.lenders
											| keyvalue;
										let i = index
									"
								>
									<br *ngIf="i !== 0 && i % 2 === 0" />
									{{
										lenderKeyValue.value.mortgageeName ||
											lenderKeyValue.value.name ||
											(lenderKeyValue.value.client | clientName)
									}}{{
										i < (vm.selectedMortgage?.lenders | keyvalue)?.length - 1
											? ', '
											: ''
									}}
								</span>
							</p>
						</div>
					</div>
					<div class="flex-1 grid grid-cols-[2fr_3fr] p-sm">
						<p class="font-bold">Priority</p>
						<p>{{ vm.selectedMortgage?.priority | ordinalSuffix }}</p>
					</div>
				</div>
			</div>
		</div>
	</ui-section>
	<ng-container [ngSwitch]="vm.selectedTab">
		<div *ngSwitchCase="ChargePageTab.XML">
			<div class="flex gap-6">
				<ui-section title="1. Review Charge XML">
					<div section-content class="flex flex-col gap-6">
						<p class="p-sm">
							Review details for your Charge XML below to confirm accuracy
							before importing into Teraview.
						</p>
						<ui-button
							data-intercom-target="review-xml-details-button"
							icon="edit-circle"
							label="Review XML Details"
							(click)="openXMLDetails()"
						></ui-button>
					</div>
				</ui-section>
				<ui-section title="2. Import Charge XML">
					<div section-content class="flex flex-col gap-6">
						<p class="p-sm">
							How would you like to import Charge XML to Teraview? Select your
							preferred method below.
						</p>
						<ng-container *ngFor="let missingField of vm.missingFields">
							<div
								class="flex justify-between self-center bg-orange-lightest w-full p-4 text-sm"
							>
								<div class="flex gap-4">
									<app-icon
										class="text-orange"
										[icon]="ICON.WARNING"
									></app-icon>
									{{ missingField.message }}
								</div>
								<span
									class="text-green w-fit cursor-pointer hover:underline ml-2"
									(click)="missingField.action()"
								>
									Add
								</span>
							</div>
						</ng-container>
						<div class="flex gap-2 items-center">
							<ui-button
								icon="copy-plus"
								label="Copy XML URL"
								[preset]="BUTTON_PRESETS.MEDIUM_EMPHASIS"
								(click)="copyXMLToClipboard()"
								[disabled]="!vm.canImportChargeXml"
								[matTooltip]="
									!vm.canImportChargeXml
										? 'Missing fields must be entered before exporting your XML file'
										: ''
								"
							></ui-button>
							<div class="text-xs text-gray items-center">
								(suggested)
								<i-tabler
									name="info-circle"
									class="w-4 h-4"
									[matTooltip]="
										'Save time searching through your downloads! Use the copy XML link to quickly import the XML into Teraview.'
									"
								></i-tabler>
							</div>
						</div>
						<div>
							<ui-button
								icon="download"
								label="Download XML"
								[preset]="BUTTON_PRESETS.MEDIUM_EMPHASIS"
								(click)="download()"
								[disabled]="!vm.canImportChargeXml"
								[matTooltip]="
									!vm.canImportChargeXml
										? 'Missing fields must be entered before exporting your XML file'
										: ''
								"
							></ui-button>
						</div>
						<p class="p-sm flex items-center gap-1">
							<ui-anchor
								[icon]="false"
								target="_blank"
								href="https://intercom.help/lawlabs/en/articles/10128446-how-to-export-your-charge-to-teraview"
								>Learn more</ui-anchor
							>
							about importing the XML into Teraview.
						</p>
					</div>
				</ui-section>
			</div>
		</div>
		<div *ngSwitchCase="ChargePageTab.REGISTRATION" class="flex flex-col gap-6">
			<app-ai-scraping-notification />
			<div class="flex gap-6">
				<ui-section
					title="Add Registration Details"
					data-intercom-target="add-registration-details-section"
				>
					<div section-content class="flex flex-col gap-6">
						<p class="p-sm">
							Add the Registered Charge details from Teraview into your matter
							below.
						</p>
						<div>
							<div
								class="flex items-center justify-between"
								[ngClass]="{
									'pb-2 px-0': vm.chargeFile,
									'px-6': !vm.chargeFile,
								}"
							>
								<label class="text-sm">Registered Charge (From Teraview)</label>
								<app-ai-document-toggle
									[matterId]="matterId"
									[matterDocumentTypes]="[MatterDocumentType.EREG_CHARGE]"
									[isChecked]="
										runMatterDocumentAiScrapings()?.[
											MatterDocumentType.EREG_CHARGE
										]
									"
								/>
							</div>

							<app-sale-file-upload
								*ngIf="!vm.chargeFile"
								type="dropzone"
								class="justify-self-center self-center w-full"
								[saleId]="matterId"
								[documentName]="'E-Registration Charge'"
								[documentType]="MatterDocumentType.EREG_CHARGE"
								(success)="onFileUploadSuccess()"
								[systemTags]="[vm.systemTag]"
							></app-sale-file-upload>
							<app-matter-file-card
								*ngIf="vm.chargeFile"
								[matterFile]="vm.chargeFile"
								(onClick)="viewFile(vm.chargeFile)"
							/>
						</div>
						<app-input
							label="Registration Number"
							[labelIcon]="AI_ICON"
							[labelToolTip]="
								vm.selectedMortgage?.fieldMappings?.registrationNumber
									? AI_TOOLTIP
									: ''
							"
							[labelIconClasses]="AI_ICON_CLASSES"
							[ngModel]="vm.selectedMortgage?.registrationNumber"
							(debounce)="setRegistrationNumber($event)"
						/>
						<app-date-picker
							label="Registration Date"
							[labelIcon]="AI_ICON"
							[labelToolTip]="
								vm.selectedMortgage?.fieldMappings?.registrationDate
									? AI_TOOLTIP
									: ''
							"
							[labelIconClasses]="AI_ICON_CLASSES"
							[ngModel]="vm.selectedMortgage?.registrationDate"
							(ngModelChange)="setRegistrationDate($event)"
						/>
					</div>
				</ui-section>
				<ui-section
					title="Add Optional Documents"
					data-intercom-target="add-optional-documents-section"
				>
					<div section-content class="flex flex-col gap-6">
						<p class="p-sm">
							Add additional registrations that are applicable to this charge.
						</p>
						<div>
							<ui-anchor
								[icon]="
									vm.selectedMortgage?.assignmentOfRents ? 'minus' : 'plus'
								"
								(click)="toggleAssignmentOfRents()"
								>{{
									vm.selectedMortgage?.assignmentOfRents ? 'Remove' : 'Add'
								}}
								Assignment of Rents</ui-anchor
							>
							<div
								class="flex flex-col pt-2 gap-6 w-full"
								*ngIf="vm.selectedMortgage?.assignmentOfRents"
							>
								<div>
									<div
										class="flex items-center justify-between"
										[ngClass]="{
											'pb-2 px-0': vm.assignmentOfRentsFile,
											'px-6': !vm.assignmentOfRentsFile,
										}"
									>
										<label class="text-sm"
											>Registered Assignment of Rents (From Teraview)</label
										>
										<app-ai-document-toggle
											[matterId]="matterId"
											[matterDocumentTypes]="[
												MatterDocumentType.ASSIGNMENT_OF_RENTS,
											]"
											[isChecked]="
												runMatterDocumentAiScrapings()?.[
													MatterDocumentType.ASSIGNMENT_OF_RENTS
												]
											"
										/>
									</div>
									<app-sale-file-upload
										*ngIf="!vm.assignmentOfRentsFile"
										type="dropzone"
										class="justify-self-center self-center w-full"
										[saleId]="matterId"
										[documentName]="'Assignment of Rents'"
										[documentType]="MatterDocumentType.ASSIGNMENT_OF_RENTS"
										[systemTags]="[vm.systemTag]"
									></app-sale-file-upload>
									<app-matter-file-card
										*ngIf="vm.assignmentOfRentsFile"
										[matterFile]="vm.assignmentOfRentsFile"
										(onClick)="viewFile(vm.assignmentOfRentsFile)"
									/>
								</div>
								<app-input
									label="Registration Number"
									[labelIcon]="AI_ICON"
									[labelToolTip]="
										vm.selectedMortgage?.fieldMappings
											?.assignmentOfRentsRegNumber
											? AI_TOOLTIP
											: ''
									"
									[labelIconClasses]="AI_ICON_CLASSES"
									[ngModel]="vm.selectedMortgage?.assignmentOfRentsRegNumber"
									(debounce)="updateAssignmentOfRentsRegNumber($event)"
								></app-input>
								<app-date-picker
									label="Registration Date"
									[labelIcon]="AI_ICON"
									[labelToolTip]="
										vm.selectedMortgage?.fieldMappings?.assignmentOfRentsRegDate
											? AI_TOOLTIP
											: ''
									"
									[labelIconClasses]="AI_ICON_CLASSES"
									[ngModel]="vm.selectedMortgage?.assignmentOfRentsRegDate"
									(ngModelChange)="updateAssignmentOfRentsRegDate($event)"
								></app-date-picker>
								<app-input
									label="PPSA Registration Number"
									[labelIcon]="AI_ICON"
									[labelToolTip]="
										vm.selectedMortgage?.fieldMappings
											?.assignmentOfRentsPpsaRegNumber
											? AI_TOOLTIP
											: ''
									"
									[labelIconClasses]="AI_ICON_CLASSES"
									[ngModel]="
										vm.selectedMortgage?.assignmentOfRentsPpsaRegNumber
									"
									(debounce)="updateAssignmentOfRentsPpsaRegNumber($event)"
								/>
							</div>
						</div>
						<div>
							<ui-anchor
								[icon]="
									vm.selectedMortgage?.generalSecurityAgreement
										? 'minus'
										: 'plus'
								"
								(click)="toggleGeneralSecurityAgreement()"
								>{{
									vm.selectedMortgage?.generalSecurityAgreement
										? 'Remove'
										: 'Add'
								}}
								General Security Agreement</ui-anchor
							>
							<div
								class="flex flex-col pt-2 gap-6 w-full"
								*ngIf="vm.selectedMortgage?.generalSecurityAgreement"
							>
								<div>
									<div
										class="flex items-center justify-between"
										[ngClass]="{
											'pb-2 px-0': vm.generalSecurityAgreementFile,
											'px-6': !vm.generalSecurityAgreementFile,
										}"
									>
										<label class="text-sm"
											>Registered General Security Agreement (From
											Teraview)</label
										>
										<app-ai-document-toggle
											[matterId]="matterId"
											[matterDocumentTypes]="[
												MatterDocumentType.GENERAL_SECURITY_AGREEMENT,
											]"
											[isChecked]="
												runMatterDocumentAiScrapings()?.[
													MatterDocumentType.GENERAL_SECURITY_AGREEMENT
												]
											"
										/>
									</div>
									<app-sale-file-upload
										*ngIf="!vm.generalSecurityAgreementFile"
										type="dropzone"
										class="justify-self-center self-center w-full"
										[saleId]="matterId"
										[documentName]="'General Security Agreement'"
										[documentType]="
											MatterDocumentType.GENERAL_SECURITY_AGREEMENT
										"
										[systemTags]="[vm.systemTag]"
									></app-sale-file-upload>
									<app-matter-file-card
										*ngIf="vm.generalSecurityAgreementFile"
										[matterFile]="vm.generalSecurityAgreementFile"
										(onClick)="viewFile(vm.generalSecurityAgreementFile)"
									/>
								</div>
								<app-input
									label="Registration Number"
									[labelIcon]="AI_ICON"
									[labelToolTip]="
										vm.selectedMortgage?.fieldMappings
											?.generalSecurityAgreementRegNumber
											? AI_TOOLTIP
											: ''
									"
									[labelIconClasses]="AI_ICON_CLASSES"
									[ngModel]="
										vm.selectedMortgage?.generalSecurityAgreementRegNumber
									"
									(debounce)="updateGeneralSecurityAgreementRegNumber($event)"
								></app-input>
								<app-date-picker
									label="Registration Date"
									[labelIcon]="AI_ICON"
									[labelToolTip]="
										vm.selectedMortgage?.fieldMappings
											?.generalSecurityAgreementRegDate
											? AI_TOOLTIP
											: ''
									"
									[labelIconClasses]="AI_ICON_CLASSES"
									[ngModel]="
										vm.selectedMortgage?.generalSecurityAgreementRegDate
									"
									(ngModelChange)="
										updateGeneralSecurityAgreementRegDate($event)
									"
								></app-date-picker>
							</div>
						</div>
					</div>
				</ui-section>
			</div>
		</div>
	</ng-container>
</div>
